import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OnboardingConfig, OnboardingConfigSchema } from '../../models/onboarding-config.model';
import { SmartrService } from '../smartr.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService extends SmartrService {
  private readonly http = inject(HttpClient);

  getConfig(): Observable<OnboardingConfig> {
    const url = environment.onboarding.config;
    return this.http.get<OnboardingConfig>(url).pipe(
      this.verifyResponse(OnboardingConfigSchema),
      catchError(() => of({} as OnboardingConfig))
    );
  }

}
